/* eslint-disable */
import React from "react";
import { useState } from "react";
import RaindropInput from "../../../ui-components/raindrop-input/raindrop-input.tsx";
import RaindropButton from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import { fetchContactUs } from "../../../services/api-raindrop";

const StratusRequestDemo = () => {
  const [fullName, setFullName] = useState();
  const [email, setEmail] = useState();
  const [message, setMessage] = useState();

  const onSubmit = () => {
    fetchContactUs({
      fullName: fullName,
      email: email,
      message: message,
    });

    alert("Request demo clicked");
  };

  return (
    <div
      id={"raindrop-website-global"}
      className={
        "flex flex-col items-center w-full text-color-dark-text-primary bg-black overflow-x-clip "
      }
    >
      <div className="flex flex-col gap-6 max-w-2xl items-center">
        <RaindropInput
          placeholder={"Full name"}
          example="John Doe"
          value={fullName}
          onChange={(e) => setFullName(e.target.value)}
        />

        <RaindropInput
          placeholder={"Email"}
          example="john.doe@gmail.com"
          type={"email"}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <RaindropInput
          placeholder={"Message"}
          type={"text"}
          example={"I'm interested in learning more about Stratus."}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />

        <RaindropButton onClick={onSubmit} />
      </div>
    </div>
  );
};

export default StratusRequestDemo;
